<div ng-if="ctrl.comments.length > 0">
    <span c-select options="ctrl.sortOptions" selected-option="ctrl.sortOrder"></span>
    <table>
        <thead>
        <th class="timestamp">{{comment.time}}</th>
        <th class="name">{{comment.name}}</th>
        <th class="message">{{comment.message}}</th>
        </thead>
        <tbody>
            <tr ng-repeat="item in ctrl.comments|orderBy: ctrl.sortOrder.value + 'Timestamp'">
                <td>{{item.Timestamp|cDate:"":"medium"}}</td>
                <td>{{item.User.DisplayName}}</td>
                <td>{{item.Message}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div ng-if="!ctrl.comments">
    <i class="fa fa-cog fa-spin fa-fw"></i>{{"comment.loading"|translate}}
</div>
<div ng-if="ctrl.comments && ctrl.comments.length === 0">
    {{"comment.no.comments"|translate}}
</div>